'use client'

import { useState } from "react"
import { Check, Copy } from "lucide-react"
import { cn } from "@/lib/util"

export default function CopyButton({ value, className, label = 'Хуулах' }: { value: string, className?: string, label?: string }) {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      setCopied(false)
    }
  }

  return (
    <button type="button" onClick={handleCopy} aria-label={label} title={label}
      className={cn("inline-flex size-8 shrink-0 items-center justify-center rounded-md text-muted-foreground hover:text-foreground hover:bg-accent transition-colors cursor-pointer", className)}>
      {copied ? <Check className="size-4 text-success" /> : <Copy className="size-4" />}
    </button>
  )
}
